import styles from './TestsetList.module.css';

const Item=({data})=>{
    return(
        <div className={styles['item']}>
            <span>{data.datasetName}</span>
        </div>
    )
}

export default function TestsetList({data}){
    return(
        // <div className={styles['wrap']}>
        //     <header>
        //         <span>Test Set</span>
        //     </header>
            <div className={styles['body']}>
                {data.map(item=>
                <Item data={item}/>
                )}
            </div>
        // </div>
    )
}